'use strict'
module.exports = {
  NODE_ENV: '"production"',
  ENV_CONFIG:'"prod"'
}



// WEBPACK FOOTER //
// ./config/prod.env.js